import { useState } from "react";

// Drop-in replacement for <img> that shows a shimmer placeholder until the
// image loads, then fades it in. No wrapper element, so it inherits any
// existing `<container> img { ... }` styling unchanged.
const LazyImage = ({
  className = "",
  alt = "",
  eager = false,
  onLoad,
  onError,
  ...rest
}) => {
  const [loaded, setLoaded] = useState(false);
  const done = (fn) => (e) => {
    setLoaded(true);
    if (fn) fn(e);
  };

  return (
    <img
      {...rest}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={`lazy-img${loaded ? " is-loaded" : ""}${
        className ? ` ${className}` : ""
      }`}
      onLoad={done(onLoad)}
      onError={done(onError)}
    />
  );
};

export default LazyImage;
